import { useGetHirerDashboardTalentSearchQuery } from 'src/graphql/generated';

export const useDashboardTalentSearch = () => {
  const { loading, error, data } = useGetHirerDashboardTalentSearchQuery();

  return { loading, error, data: data?.hirerDashboardTalentSearch };
};
